import { useEffect, useState } from 'react';
import styles from '../styles/home.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';

import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

interface WooProduct {
  id: number;
  name: string;
  price: string;
  price_html?: string;
  permalink: string;
  images: { src: string }[];
}

const consumerKey = "ck_3fc8407fce153701c77ec7ab7c5caa83550f0202";
const consumerSecret = "cs_cef5a587aa273c59a6f57ec7fcfad86ae62d9141";
const basicAuth = typeof window !== 'undefined' ? btoa(`${consumerKey}:${consumerSecret}`) : '';

export const TitaCoinsShowcase = () => {
  const [products, setProducts] = useState<WooProduct[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch('https://titacoins.dreamhosters.com/wp-json/wc/v3/products?orderby=date&order=desc&per_page=10', {
      headers: {
        'Authorization': `Basic ${basicAuth}`
      }
    })
      .then(res => {
        if (!res.ok) throw new Error('Error al obtener productos');
        return res.json();
      })
      .then(data => {
        setProducts(data);
        setLoading(false);
      })
      .catch(() => {
        setError('No se pudieron cargar los productos');
        setLoading(false);
      });
  }, []);

  if (loading) return <div className={styles.titacoinsShowcase}>Cargando productos...</div>;
  if (error) return <div className={styles.titacoinsShowcase}>{error}</div>;

  return (
    <section className={styles.titacoinsShowcase}>
      <h2>Nuevos productos en TitaCoins</h2>
      <div className={styles.titacoinsSliderContainer}>
        <Swiper
          modules={[Navigation, Pagination, A11y]}
          spaceBetween={30}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
          className={styles.titacoinsSlider}
          breakpoints={{
            640: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            1400: {
              slidesPerView: 4,
              spaceBetween: 40,
            }
          }}
        >
          {products.map(product => (
            <SwiperSlide key={product.id} className={styles.titacoinsProductCard}>
              <img src={product.images?.[0]?.src} alt={product.name} />
              <h3>{product.name}</h3>
              <p dangerouslySetInnerHTML={{ __html: product.price_html || (product.price + ' TitaCoins') }} />
              <a href={product.permalink} target='_blank' rel='noopener noreferrer'>Ver más</a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}; 